import { configureStore, getDefaultMiddleware } from 'redux-starter-kit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import viaReducer from './viaReducer';


export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });


const viaStore = configureStore({
  reducer: {
    via: viaReducer,
    router: connectRouter(history),
  },
  middleware: [...getDefaultMiddleware(), routerMiddleware(history)],
});

export default viaStore;
